module.exports = __webpack_public_path__ + "static/media/revista_sep 2008.15a79f52.png";